class reportTemplateSettingCtrl {
    constructor($scope, httpRequest, $state, logger, $timeout) {
        const dicData = ['bi_report_type', 'bi_report_publish_state'] // 数据类型的数据字典
        $scope.dictionary = {
            userAllOrgList: [],
        } // 数据字典的数据
        $scope.reportTable = {
            head: [
                '报表名称',
                '发布状态',
                '使用对象',
                '报表性质',
                '创建机构',
                '发布日期',
            ],
            reportList: [{
                name: '财税对比',
                status: '已发布',
                usage: '深圳航信',
                property: '自定义报表',
                organization: 'admin',
                date: '2018-06-28',
            }, {
                name: '财税对比',
                status: '未发布',
                usage: '深圳航信',
                property: '自定义报表',
                organization: 'admin',
                date: '2018-06-28',
            }],
            total: 0,
            tableDropdownConfig: [{
                label: '预览',
                handler(item) {
                    $state.go('system.settingcenter.reportTemplateSetting.preview', { id: item.templateId })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('report_preview')
                },
            }, {
                label: '编辑',
                handler(item) {
                    $state.go('system.settingcenter.reportTemplateSetting.edit', { id: item.templateId })
                },
                showWhile(item, hasPermit) {
                    if (item.templateType === 1) return
                    return hasPermit('report_edit')
                },
            }, {
                label: '取消发布',
                handler(item) {
                    cancelPublish(item)
                },
                showWhile(item, hasPermit) {
                    if (item.publishState === 0 || item.templateType === 1) return
                    return hasPermit('report_publish')
                },
            }, {
                label: '删除',
                handler(item) {
                    deleteTemplate(item)
                },
                showWhile(item, hasPermit) {
                    if (item.publishState === 1) return
                    return hasPermit('report_delete')
                },
            }],
        }
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                orgList: [],
                publishState: '',
                templateName: '',
                templateType: '',
            },
        }
        $scope.reset = function () {
            $scope.queryParam.param = {
                orgList: [],
                publishState: '',
                templateName: '',
                templateType: '',
            }
        }
        // $scope.reset()
        // 跳转到新增页面
        $scope.goToAdd = () => {
            $state.go('system.settingcenter.reportTemplateSetting.add')
        }
        // 分页查询模板文件配置
        const pageQueryReportTemplate = async () => {
            try {
                const result = await httpRequest.post_pageQueryReportTemplate($scope.queryParam)
                $timeout(() => {
                    $scope.reportTable.reportList = result.data.value.list
                    $scope.reportTable.total = result.data.value.total
                })
            } catch (e) {
                console.log(e)
            }
        }
        pageQueryReportTemplate()
        // 点击取消发布执行的方法
        const cancelPublish = (params) => {
            logger.logMsg({
                title: '取消报表模板',
                message: '确认要取消发布该报表模板吗?',
                btn: ['确定', '取消'],
                icon: 'tishi',
                yes(index) {
                    try {
                        httpRequest.post_cancelPublishReportTemplate(params.templateId).then((res) => {
                            if (res.data.success) {
                                pageQueryReportTemplate()
                                layer.close(index)
                                logger.logSuccess('取消发布模板成功!')
                            }
                        })
                    } catch (e) {
                        console.log(e)
                        logger.logError(e)
                    }
                },
            })
        }
        // 点击删除模板执行的方法
        const deleteTemplate = (params) => {
            logger.logMsg({
                title: '删除报表模板',
                message: '确认要删除该报表模板吗?',
                btn: ['确定', '取消'],
                icon: 'tishi',
                yes(index) {
                    try {
                        httpRequest.post_deleteReportTemplate(params.templateId).then((res) => {
                            if (res.data.success) {
                                pageQueryReportTemplate()
                                layer.close(index)
                                logger.logSuccess('删除模板成功!')
                            }
                        })
                    } catch (e) {
                        console.log(e)
                        logger.logError(e)
                    }
                },
            })
        }
        // 获取报表性质、使用对象、发布状态的数据字典
        Promise.all([
            httpRequest.get_dictByTypeArr(dicData),
            httpRequest.post_getSysOrganizationList({
                pageNum: 1,
                pageSize: 1000,
                param: {
                    orgStatus: 1,
                },
            }),
        ]).then((res) => {
            $scope.dictionary = res[0].data.value
            $scope.dictionary.userAllOrgList = res[1].data.value.list
            // console.log(res[1].data.value.list)
        }).catch((err) => console.log(err))
        // 点击搜索执行的方法
        $scope.queryList = () => {
            pageQueryReportTemplate()
        }
        // 选择分页执行的方法
        $scope.paging = () => {
            pageQueryReportTemplate()
        }
        // 机构变化
        $scope.orgSelectChange = function (orgArr) {
            $scope.queryParam.param.orgList = []
            orgArr.forEach((org) => $scope.queryParam.param.orgList.push(org.orgId))
        }
        $scope.queryConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            queryType: 'tree',
            parentIdName: 'parentOrgId',
            multiple: true,
            parentId: -1,
        }
    }
}

reportTemplateSettingCtrl.$inject = ['$scope', 'httpRequest', '$state', 'logger', '$timeout']

export default reportTemplateSettingCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/reportTemplateSetting/reportTemplateSettingCtrl.js